export default function EFXQuiet(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="122" height="30" viewBox="0 0 122 30" fill="none" {...props}>
            <g clipPath="url(#clip0_2723_9266)">
                <path d="M79.9258 18.2449H82.7017L86.3692 4.55127H83.596L79.9258 18.2449Z" fill="currentColor" />
                <path
                    d="M56.5013 12.1597H52.8815L54.726 15.3921H48.3196C48.1869 15.3997 48.0593 15.3397 47.9805 15.2326C47.9018 15.1254 47.8826 14.9857 47.9295 14.8613L49.7872 7.93488C49.8764 7.63389 50.1452 7.42144 50.4586 7.40411H59.2162C59.3485 7.3974 59.4753 7.45781 59.5534 7.56479C59.6315 7.67178 59.6503 7.81093 59.6036 7.93488L58.5288 11.9474L60.4077 15.2382C60.4263 15.1798 60.4475 15.1214 60.4635 15.063L62.4273 7.73584C62.8997 5.97637 61.8541 4.55127 60.0973 4.55127H51.1168C49.3599 4.55127 47.5527 5.97637 47.0803 7.73584L45.1165 15.063C44.6468 16.8198 45.6897 18.2476 47.4465 18.2476H59.9858L56.5013 12.1597Z"
                    fill="currentColor"
                />
                <path
                    d="M75.1704 15.488H65.537L68.4562 4.56226H65.6034L62.647 15.6021C62.2542 17.0697 63.1247 18.2559 64.5896 18.2559H77.2722L80.9424 4.56226H78.0896L75.1704 15.488Z"
                    fill="currentColor"
                />
                <path
                    d="M121.711 4.55127H106.342L105.578 7.39881H111.876L108.97 18.2449H111.746L114.651 7.39881H120.949L121.711 4.55127Z"
                    fill="currentColor"
                />
                <path d="M85.3477 18.2453H100.684L101.446 15.4031H88.8852L89.5752 12.821H102.138L102.9 9.97607H87.5636L85.3477 18.2453Z" fill="currentColor" />
                <path d="M88.2559 7.39615H103.592L104.354 4.55127H89.0175L88.2559 7.39615Z" fill="currentColor" />
                <path d="M35.2715 12.8341H42.933L43.6947 9.98657H36.0358L35.2715 12.8341Z" fill="currentColor" />
                <path d="M19.1725 0.849609H11.4473L18.1959 9.97871L23.1214 6.19969L19.1725 0.849609Z" fill="currentColor" />
                <path d="M27.0469 21.9496H34.7721L28.5808 13.5742L23.252 16.8145L27.0469 21.9496Z" fill="currentColor" />
                <path
                    d="M41.846 0.849609H32.141L15.3609 13.7232H19.0338L0.486328 29.2878L32.2604 9.98933H28.5451L41.846 0.849609Z"
                    fill="url(#paint0_linear_2723_9266)"
                />
            </g>
            <defs>
                <linearGradient id="paint0_linear_2723_9266" x1="39.5584" y1="0.849609" x2="0.534751" y2="29.2413" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
                <clipPath id="clip0_2723_9266">
                    <rect width="121.223" height="28.4382" fill="currentColor" transform="translate(0.486328 0.849609)" />
                </clipPath>
            </defs>
        </svg>
    );
}
